export default "__VITE_ASSET__BvuGn4eW__";